import { combineReducers } from "redux";

import contentful from "./contentful";
import announcements from "./announcements";

const reducers = combineReducers({ contentful, announcements });

export default reducers;
